import { Link } from 'react-router-dom';
import willow from '../assets/images/willow-web.png';
import band from '../assets/images/KenaydaLive.jpeg';
import PageHeader from '../components/PageHeader';

const rules = [
    'No one hears the song until the day it’s recorded',
    'Each song is tracked in a single day',
    'Every recording uses different personnel',
]

const About = () => {
    return (
        <>
            <PageHeader title='About' kicker='Belfast, Northern Ireland' image={band} imagePosition='center 35%' />
            <section className='band'>
                <div className='container about'>
                    <div className='about__copy'>
                        <p className='lead'>
                            O, Kenayda are a five-piece alternative rock band from Belfast whose debut album <em>Orphans</em> arrived in June of 2026.
                        </p>
                        <p className='body-lg'>
                            Built on downtuned guitars, big choruses and hooks that don’t let go, the record updates the spirit of
                            1990s alt-rock for a contemporary audience — loud where it needs to be, melodic where it counts.
                        </p>
                        <p className='body-lg'>
                            <em>Orphans</em> is a cohesive collection of songs that never quite fit any previous musical incarnation.
                            To force raw energy onto the record, the band set three rules.
                        </p>
                    </div>
                    <figure className='about__image'>
                        <img src={willow} alt='Kick drum skin painted with a portrait of a dog' />
                    </figure>
                </div>
            </section>

            <section className='band band--light'>
                <div className='container'>
                    <p className='eyebrow'>The rules</p>
                    <ol className='rules'>
                        {rules.map((rule, index) => (
                            <li className='rules__item' key={rule}>
                                <span className='rules__num'>0{index + 1}</span>
                                <span className='rules__text'>{rule}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            <section className='band'>
                <div className='container container--narrow about__outro'>
                    <p className='body-lg'>
                        Mirroring the consume-and-dump culture the songs respond to, almost every track clocks in under three
                        minutes. That same ethos has already pushed the band into the next record.
                    </p>
                    <Link className='btn' to='/collaborators'>Meet the collaborators</Link>
                </div>
            </section>
        </>
    )
}

export default About
